var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonMxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.990234,
    y: 1.20422,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5728_64469",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.990234,
    y: 1.20422,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5728_64469)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7402,
    y: 0.954224,
    width: 7,
    height: 15,
    fill: "#E3283E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.740234 15.9542H7.74023V0.954224H0.740234V15.9542Z",
    fill: "#128A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9069 7.95422C9.9069 7.58603 9.60842 7.28756 9.24023 7.28756C8.87204 7.28756 8.57357 7.58603 8.57357 7.95422H9.9069ZM9.90336 10.262C10.2218 10.4467 10.6298 10.3384 10.8146 10.0199C10.9994 9.70145 10.891 9.29349 10.5725 9.1087L9.90336 10.262ZM11.9572 9.0787C11.647 9.27708 11.5564 9.68934 11.7547 9.99952C11.9531 10.3097 12.3654 10.4003 12.6756 10.2019L11.9572 9.0787ZM13.9069 7.95422C13.9069 7.58603 13.6084 7.28756 13.2402 7.28756C12.872 7.28756 12.5736 7.58603 12.5736 7.95422H13.9069ZM8.57357 7.95422C8.57357 8.94084 9.10972 9.80146 9.90336 10.262L10.5725 9.1087C10.1731 8.87694 9.9069 8.44628 9.9069 7.95422H8.57357ZM12.6756 10.2019C13.4146 9.72928 13.9069 8.89946 13.9069 7.95422H12.5736C12.5736 8.42578 12.3293 8.84072 11.9572 9.0787L12.6756 10.2019Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2402 8.95422C11.7925 8.95422 12.2402 8.28265 12.2402 7.45422C12.2402 6.6258 11.7925 5.95422 11.2402 5.95422C10.6879 5.95422 10.2402 6.6258 10.2402 7.45422C10.2402 8.28265 10.6879 8.95422 11.2402 8.95422Z",
    fill: "#C59262"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonMxIcon);
export default __webpack_public_path__ + "static/media/amazon-mx-icon.9b339128e9b09f384545ac391d516bcb.svg";
export { ForwardRef as ReactComponent };